import React from "react";
import HeroArea from "./HeroArea";
import PropertiesArea from "./PropertiesArea";
import ServiceSection from "./ServiceSection";

const Properties = () => {
  return (
    <>
      <HeroArea />
      <PropertiesArea />
      <ServiceSection />
    </>
  );
};

export default Properties;
